module.exports = __webpack_public_path__ + "static/media/icon_shared-entry.e8b15e82.svg";